import axios from "axios-jsonp-pro";

const URL = {
  local: "http://localhost:8000/server-side/api.php",
  live: "https://servizi.istitutomaxplanck.edu.it/opendays/api.php",
  getUrl: () => {
    return location.host.indexOf("localhost") > -1 ? URL.local : URL.live;
  },
};

export const getJsonData = async (key = "") => {
  try {
    const response = await axios.jsonp(URL.getUrl() + key);
    console.log(response);
    return response;
  } catch (error) {
    console.error(error);
  }
};
